module.exports = __webpack_public_path__ + "img/gb-eng.e22b8524.svg";